import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PortalComponent } from './portal.component';
import { RouterModule, Routes } from '@angular/router';
import { ShareModule } from '../share.module';
import { ControlsModule } from 'src/core/controls/shared/controls.mudule';
import { MatTabsModule } from '@angular/material/tabs';
import { MatMenuModule } from '@angular/material/menu';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LogoComponent } from './logo/logo.component';
import { SliderComponent } from './slider/slider.component';
import { SocialComponent } from './social/social.component';
import { GoodsComponent } from './goods/goods.component';
import { HttpClientModule } from '@angular/common/http';
import { UploadComponent } from './upload/upload.component';
import { DownloadComponent } from './download/download.component';
import { FileManagerComponent } from './file-manager/file-manager.component';
import { UploadDownloadService } from './file-upload/upload-download.service';
import { HintFileSizeComponent } from './upload/hint-file-size/hint-file-size.component';


const routes: Routes = 
  [
    {
    path: '', component: PortalComponent,
      children: 
      [
        {
          path:'logo', component: LogoComponent
        },
        {
          path:'goods', component: GoodsComponent
        },
        {
          path:'slider', component: SliderComponent
        },
        {
          path:'social', component: SocialComponent
        }
      ],
      runGuardsAndResolvers: 'always'
    }
  ]

@NgModule({
  declarations: [
    PortalComponent,
    LogoComponent,
    SliderComponent,
    SocialComponent,
    GoodsComponent,
    UploadComponent,
    DownloadComponent,
    FileManagerComponent,
    HintFileSizeComponent
  ],
  imports: [
    RouterModule.forChild(routes),
    CommonModule,
    ShareModule,
    MatTabsModule,
    MatMenuModule,
    ControlsModule,
    ReactiveFormsModule,
    FormsModule,
    HttpClientModule
  ],
  providers: [UploadDownloadService]
})
export class PortalModule { }
